import React from 'react';

function icon() {
	const icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="24"
			height="24"
		>
			<rect x="2" y="2" width="20" height="20" rx="3" fill="#008080" />
			<rect x="4" y="6" width="8" height="2" rx="0" fill="white" />
			<rect x="4" y="9" width="6" height="2" rx="0" fill="white" />
			<rect x="4" y="12" width="7" height="2" rx="0" fill="white" />
			<rect x="4" y="15" width="5" height="2" rx="0" fill="white" />
			<rect x="13" y="6" width="7" height="11" rx="1" fill="white" />
		</svg>
	);
	return icon;
}

export default icon;
